import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSketchbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSketchbook"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 5C3.5 3.61929 4.61929 2.5 6 2.5H18C19.3807 2.5 20.5 3.61929 20.5 5V19C20.5 20.3807 19.3807 21.5 18 21.5H6C4.61929 21.5 3.5 20.3807 3.5 19V5ZM8 7.5C8 7.22386 8.22386 7 8.5 7H15.5C15.7761 7 16 7.22386 16 7.5C16 7.77614 15.7761 8 15.5 8H8.5C8.22386 8 8 7.77614 8 7.5ZM8 11.5C8 11.2239 8.22386 11 8.5 11H12.5C12.7761 11 13 11.2239 13 11.5C13 11.7761 12.7761 12 12.5 12H8.5C8.22386 12 8 11.7761 8 11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSketchbook;
